export default {
  title: 'WinOrder',
  form: {
    store_id: {
      label: 'Butiks-ID: ',
    },
    url: {
      label: 'URL: ',
    },
    username: {
      label: 'Brugernavn: ',
      placeholder: 'Brugernavn til godkendelse mellem din shop og WinOrder',
      validation: {
        required: 'Brugernavn må ikke være tomt',
        min: 'Brugernavnet skal være mindst 3 tegn langt',
      },
    },
    password: {
      label: 'Adgangskode: ',
      placeholder: 'Adgangskode til godkendelse mellem din shop og WinOrder',
      validation: {
        required: 'Adgangskode må ikke være tom',
        complexity: 'Adgangskoden skal være mindst 8 tegn lang og indeholde mindst ét bogstav',
      },
    },
  },
  labels: {
    credentials: 'Legitimationsoplysninger:',
  },
  instructions: {
    title: 'Opsætningsvejledning:',
    step_1: 'Åbn „Indstillinger“ → „Programindstillinger“ i WinOrder.',
    step_2: 'Allerøverst finder du knappen „Online shop-opsætning“.',
    step_3:
      'I det næste vindue finder du alle de shops, der er forudkonfigureret i WinOrder. Vælg „FoodAmigos“, og klik derefter på „Næste“.',
    step_4:
      'I det næste vindue skal du i feltet „Webservicens URL“ erstatte <0>{{storeid_placeholder}}</0> med <1>{{company_id}}</1>. <br />Det endelige resultat skal se sådan ud: <2>{{url}}</2>',
    step_5: 'Indtast <ClickToCopy>{{username}}</ClickToCopy> i feltet „Brugernavn“ i samme vindue.',
    step_6:
      'Indtast <ClickToCopy>{{password}}</ClickToCopy> i feltet „Adgangskode“ i samme vindue. Klik derefter på knappen „Næste“.',
    step_7:
      'WinOrder tester nu forbindelsen til FoodAmigos-grænsefladen. Klik på „Næste“ og i det følgende vindue på „Udfør“.',
    step_8: 'Gem indstillingerne.',
  },
  buttons: {
    save: 'Gem',
    cancel: 'Annuller',
    edit: 'Rediger',
  },
  toasts: {
    error: 'Kunne ikke gemme ændringerne',
    success: 'Ændringerne er gemt',
  },
};
